import React from "react";
import {useDispatch, useSelector} from 'react-redux';

interface IProps {
    image: any
}

const PlayAnimation = (props: IProps) => {
    const dispatch = useDispatch();
    const [animationEnded, setAnimationEnded] = React.useState<boolean>(false);
    const animationDOMRects = useSelector((state: any) => state.questionReducer.animationDOMRects);
    const welcomeVideoPlay = useSelector((state: any) => state.questionReducer.welcomeVideoPlay);
    const cartDOMRects = useSelector((state: any) => state.questionReducer.cartDOMRects);
    let {image} = props;
    let {left, top, width, height} = animationDOMRects;

    let animation = `
            @keyframes fly {
                0% { transform: translate(0) scale(1); }
                100% { transform: translate(${(cartDOMRects.left + (cartDOMRects.width / 2)) - left - (width / 2)}px, ${(cartDOMRects.top + (cartDOMRects.height / 2)) - top - (height / 2)}px) scale(0); }
            }
        `;

    if (cartDOMRects.play === false) {
        animation = `
        @keyframes fly {
            0% { transform: translate(${(cartDOMRects.left + (cartDOMRects.width / 2)) - left - (width / 2)}px, ${(cartDOMRects.top + (cartDOMRects.height / 2)) - top - (height / 2)}px) scale(0); }
            100% { transform: translate(0) scale(1); }
        }
    `;
    }


    const animationEnd = () => {
        setAnimationEnded(true);
    }

    return (
        <div>

            {(animationEnded === false) && <div
                style={{
                    position: "absolute",
                    zIndex: 10,
                    top: top + window.scrollY + "px",
                    left: left + window.scrollX + "px",
                    width: width + "px",
                    height: height + "px",
                    animationDuration: "1s",
                    animationIterationCount: 1,
                    animationName: "fly",
                    animationTimingFunction: "ease",
                    animationFillMode: "forwards"

                }}
                onAnimationEnd={animationEnd}
            >
                <style children={animation}/>
                <img
                    src={image}
                    style={{
                        width: "100%"
                    }}
                />
            </div>}
        </div>
    )
}

export default PlayAnimation;
